module.exports = __webpack_public_path__ + "img/h8.d509fd92.png";